"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForceLogoutException = void 0;
class ForceLogoutException extends Error {
    constructor(e) {
        super(e);
        this.stack = e.stack;
        this.name = "ForceLogoutException";
        this.code = "FORCE_LOGOUT";
    }
}
exports.ForceLogoutException = ForceLogoutException;
